import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_DELAY_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    tripCancellation: 'false',
    enableTime: null,
    // Travel Cancellation
    areYouCancellingTheTripDueToMedicalReasons: 'false',
    schoolName: '',
    companyNameTravelCancellation: '',
    addressTravelCancellation: '',
    cityTravelCancellation: '',
    stateTravelCancellation: '',
    zipCodeTravelCancellation: '',
    contactTravelCancellation: '',
    phoneNumberTravelCancellation: '',
    includedInPackageTravelCancellation: '',
    dateTravelCancellation: '',
    reasonForTravelCancellation: '',
    nameOfPersonHavingSicknessTravelCancellation: '',
    dateOfBirthTravelCancellation: '',
    relationshipToClaimantTravelCancellation: '',
    dateSicknessOrInjuryBeganTravelCancellation: '',
    dateEndedTravelCancellation: '',
    natureOfSicknessOrInjuryTravelCancellation: '',
    lossInformationItemsTravelCancellation: [],
    fromDateTravelCancellation: '',
    toDateTravelCancellation: '',
    dateOfInitialPaymentDepositTravelCancellation: '',
    insuredsTravelCancellation: [],

    // Airline Reissue Or Cancellation Fees
    areYouClaimingForAirlineReissueOrCancellationFees: 'false',

    // Reinstate Frequent Traveler Awards
    areYouClaimingForReinstateFrequentTravelerAwards: 'false',
  },
  errors: [],
});

const initialTravelDelayState = {
  form: {
    travelDelay: 'false',
    reasonsForDelay: [],
    companyNameTravelDelay: '',
    addressTravelDelay: '',
    cityTravelDelay: '',
    stateTravelDelay: '',
    zipCodeTravelDelay: '',
    contactTravelDelay: '',
    phoneNumberTravelDelay: '',
    dateOfInitialPaymentDeposit: '',
    includedInPackageForDelay: '',
    dateYouWereDueToDepart: '',
    timeYouWereDueToDepart: null,
    dateTripWasDelayed: '',
    dateDelayEnded: '',
    dateYouActuallyDeparted: '',
    timeYouActuallyDeparted: null,
    delayInformationItems: [],
  },
};

function tripCancellationStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_DELAY_STATE:
      return state
          .setIn(['form', 'delayInformationItems'], [])
          .mergeDeep(initialTravelDelayState);
    default:
      return state;
  }
}

export default tripCancellationStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripCancellationStep/reducer.js